import {
  FlatList,
  View,
  TouchableOpacity,
  Image,
  Platform,
  Dimensions,
} from "react-native";
import React, { useState, useRef, memo, useEffect } from "react";
import { LinearGradient } from "expo-linear-gradient";
import { ResizeMode, Video } from "expo-av";

import { BlurView } from "expo-blur";
import ConfirmedGoldenBottom from "../../../Bookings/components/ConfirmedGoldenBottom";
import PendingBlackBottom from "../../../Bookings/components/PendingBlackBottom";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import dimensions from "../../../../../globalStyles/dimensions";
import ExperienceIcons from "../../../../../assets/Icons/ExperienceIcons";

const Circle = ({ isActive }: { isActive: boolean }) => (
  <View
    style={{
      height: 8,
      width: 8,
      backgroundColor: isActive ? Colors.white10 : Colors.light30,
      borderRadius: 50,
      marginHorizontal: 2,
    }}
  />
);

const videoExtensions = [
  ".mp4",
  ".mov",
  ".wmv",
  ".flv",
  ".avi",
  ".avchd",
  ".mkv",
  ".webm",
];

const Carousel = ({
  data,
  status,
  height,
}: {
  data: any;
  status?: string;
  height?: number;
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const flatListRef = useRef<FlatList | null>(null);
  const isVideoUri = (uri: string) => {
    return videoExtensions?.some((extension) => uri?.includes(extension));
  };

  const renderItem = ({ item, index }: { item: string; index: number }) => {
    return (
      <View
        style={{
          backgroundColor: Colors.black90,
          width: "100%",
        }}
      >
      
        {/* <LinearGradient
          colors={["transparent", Colors.black90]}
          style={{
            position: "absolute",
            width:
              Platform.OS === "ios" || Platform.OS === "android"
                ? dimensions.windowWidth
                : 390,
            height:
              Platform.OS === "ios" || Platform.OS === "android"
                ? dimensions.windowHeight / 7
                : 20,
            bottom: 0,
            zIndex: 1,
          }}
        /> */}
        {isVideoUri(item) ? (
          <View
            style={{
              width:
                Platform.OS === "ios" || Platform.OS === "android"
                  ? dimensions.windowWidth
                  : 390,
              height:
                Platform.OS === "ios" || Platform.OS === "android"
                  ? "100%"
                  : 400,
            }}
          >
            <Video
              source={{ uri: item }}
              style={{
                width: Platform.OS === "web" ? 390 : dimensions.windowWidth,
                height: "100%",
                alignSelf: "center",
              }}
              isLooping
              shouldPlay
              resizeMode={
                Platform.OS === "web" ? ResizeMode.CONTAIN : ResizeMode.COVER
              }
              isMuted={isMuted}
            />
            <TouchableOpacity
              style={{
                position: "absolute",
                bottom:
                  Platform.OS === "ios" || Platform.OS === "android"
                    ? dimensions.windowHeight * 0.02
                    : 0,
                zIndex: 999,
                right:
                  Platform.OS === "ios" || Platform.OS === "android"
                    ? dimensions.windowWidth * 0.02
                    : 0,
              }}
              onPress={() => setIsMuted((prev) => !prev)}
            >
              {isMuted ? (
                <ExperienceIcons.MuteIcon
                  style={{
                    bottom: 15,
                    right: dimensions.windowWidth * 0.02,
                  }}
                />
              ) : (
                <ExperienceIcons.UnmuteIcon
                  style={{
                    bottom: 15,
                    right: dimensions.windowWidth * 0.02,
                  }}
                />
              )}
            </TouchableOpacity>
          </View>
        ) : (
          <>
            <Image
              source={{ uri: item }}
              style={{
                width:
                  Dimensions.get("window").width < 500
                    ? Dimensions.get("window").width
                    : "100%",
                height: Platform.OS === "web" ? 600 : "100%",
              }}
              // resizeMode="cover"
            />
            <View>
              {status === "Confirmed" && <ConfirmedGoldenBottom />}
              {status === "Pending" && <PendingBlackBottom />}
            </View>
          </>
        )}
      </View>
    );
  };

  const onScroll = (event: any) => {
    const contentOffset = event.nativeEvent.contentOffset.x;
    const currentIndex = Math.round(contentOffset / dimensions.windowWidth);
    setActiveIndex(currentIndex);
  };

  useEffect(() => {
    // Reset activeIndex and isMuted when data or status changes
    setActiveIndex(0);
    setIsMuted(true);
  }, [data, status]);

  return (
    <View
      style={{
        // height: dimensions.windowHeight / 2,
        height: height ? "100%" : dimensions.windowHeight / 2,
        width: dimensions.windowWidth,
      }}
    >
      {/* Image slider */}
      {Array.isArray(data) && data.length ? (
        <FlatList
          ref={(ref) => (flatListRef.current = ref)}
          data={data}
          renderItem={renderItem}
          horizontal
          pagingEnabled
          onMomentumScrollEnd={onScroll}
          onScroll={onScroll}
          showsHorizontalScrollIndicator={false}
        />
      ) : (
        <View style={{ width: "100%", height: "100%" }}>
          <Image
            source={{
              uri: "https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg?w=900",
            }}
            style={{ width: "100%", height: "100%" }}
          />
        </View>
      )}

      {/* Circles */}
      {Array.isArray(data) && data.length > 1 && (
        <BlurView
          style={{
            position: "absolute",
            bottom: Platform.OS === "web" ? 20 : dimensions.windowHeight * 0.04,
            overflow: "hidden",
            paddingHorizontal: 2,
            paddingVertical: 3,
            borderRadius: 50,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
          }}
        >
          {data.map((_: any, index: number) => (
            <Circle key={index} isActive={index === activeIndex} />
          ))}
        </BlurView>
      )}
      {
        <View>
          {status === "Confirmed" && <ConfirmedGoldenBottom />}
          {status === "Pending" && <PendingBlackBottom />}
        </View>
      }
    </View>
  );
};

export default memo(Carousel);
